<template>
    <!-- large modal -->
    <teleport to="body">
      <div class="modal fade" id="largeModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true" >
  <div class="modal-dialog modal-xl" >
    <div class="modal-content">
     <!--  <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Large Modal</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->
      <div class="modal-body logpop" >
        

<div class="row pad50">
  
<div class="col-md-7">
      <div class="membership marb3">
      <h6>Get Started</h6>
        <p class="xsfon13">Sign in to your Palaxi   Cinemas account to see your booking history and profile setting</p>
        <form>
      


          <div class="or">
              
    
             <!-- <a href="#" class="facbg"><i class="lni lni-facebook-filled"></i>
            <small>with Facebook</small>
            </a> -->
             <a href="#" class="gool"><i class="lni lni-google"></i> 
            <small>with Google+</small>
            </a>

             <span>or</span>
               </div>



        <div class="form-group">
            <input type="text" placeholder="E-mail Address">
          </div>
          <!-- end form-group -->
        <div class="form-group">
            <input type="password" placeholder="Password"><i class="lni lni-eye"></i>
          </div>
          <!-- end form-group -->
        <div class="form-group">
            <a href="#" class="xsfon12"><input type="checkbox" checked="true"> Forgot Password?
</a>    <a href="#" class="xsfon12" style="margin-left: 10px; "><input type="checkbox" checked="true"> Member Registration
</a>
          </div>
          <!-- end form-group -->
        <div class="form-group">
            <input type="submit" value="Login">
          </div>
          <!-- end form-group -->
          
       
             <!-- end or -->
        </form>
      </div>
      <!-- end membership -->
      </div>
<div class="col-md-5 ">

<div class="membership marb3"> <h6>Book as guest?</h6></div>
    <p class="xsfon13">As a guest, you may miss out on offers and other account features.</p>
    <div class="form-group">
     
      <router-link to="/index" class=" contbtn" @click="tryClose" >Continue</router-link>
<!-- <a href="movies-seat.html" class=" contbtn " @click="tryClose">  Continue</a> -->

          </div>
</div>

<div>   </div>

</div>



      </div>

    </div>
  </div>
</div>
    </teleport>

</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    
  },
  emits: ['close'],
  methods: {
    tryClose() {
      this.$emit('close');
    },
  },
};
</script>